// extracted by mini-css-extract-plugin
export default {"title":"success_title_F2Orf"};